import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoutingModule } from './oauth2-scope-management.routing.module';
import { ListOauth2ScopesPageComponent } from './list-oauth2-scopes-page/list-oauth2-scopes-page.component';
import { PageHeaderModule } from '../../shared/components/page-header/page-header.module';
import { CreateOauth2ScopeComponent } from './create-oauth2-scope-page/create-oauth2-scope.component';
import { Oauth2ScopesService } from './scopes-service';
import { UIKitModule } from '@vendasta/uikit';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditOauth2ScopeComponent } from './edit-oauth2-scope-page/edit-oauth2-scope.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { LexiconModule } from '@galaxy/lexicon';

const MaterialModules = [
  MatCardModule,
  MatButtonModule,
  MatInputModule,
  MatFormFieldModule,
  MatSnackBarModule,
  MatPaginatorModule,
  MatTableModule,
  MatSortModule,
  MatDialogModule,
  MatTooltipModule,
  MatExpansionModule,
  MatIconModule,
  MatChipsModule,
];

@NgModule({
  declarations: [ListOauth2ScopesPageComponent, CreateOauth2ScopeComponent, EditOauth2ScopeComponent],
  imports: [
    CommonModule,
    RoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModules,
    PageHeaderModule,
    UIKitModule,
    GalaxyPageModule,
    LexiconModule.forChild(),
  ],
  providers: [Oauth2ScopesService],
})
export class Oauth2ScopeManagementModule {}
